import { render, staticRenderFns } from "./website-contact.vue?vue&type=template&id=c3a8b3d2&scoped=true"
import script from "./website-contact.vue?vue&type=script&lang=js"
export * from "./website-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a8b3d2",
  null
  
)

export default component.exports